module.exports = __webpack_public_path__ + "img/vue1-milieu_vert.bdbec324.png";